import { useContext } from 'react'
import { UGEContext } from '../context'
import { ugeEditors } from '../types'
import { gradientFromEditor, iconFromEditor, iconScaleFromEditor } from '../utilities/editor'
import { Button, Navigation } from './style'

export { default as CloseButton } from './close'

type Props = {
    className?: string
}

const UGENavigation = ({ className }: Props) => {
    const { activeEditor, loaded, openEditor } = useContext(UGEContext)

    return (
        <Navigation className={className}>
            {ugeEditors.map((editor) => {
                const gradient = gradientFromEditor(editor)
                const icon = iconFromEditor(editor)
                const iconScale = iconScaleFromEditor(editor)
                const isActive = editor === activeEditor
                const isDefault = editor === 'default'

                return (
                    <Button
                        disabled={!loaded}
                        gradient={isDefault && !isActive ? undefined : gradient}
                        icon={icon}
                        iconColor="#fff"
                        iconScale={iconScale}
                        inverted={!isActive}
                        key={editor}
                        size="large"
                        onClick={() => openEditor(editor)}
                    />
                )
            })}
        </Navigation>
    )
}

export default UGENavigation
